import type { MenuItem } from '../interfaces';

import { ExternalUrls } from '@/constants';
import { Features } from '@/models/bootstrap/plan';
import { Permissions } from '@/models/user';
import { privateRoutes } from '@/routes/private-routes';

export const commonMenuItems: MenuItem[] = [
  privateRoutes.MyProfile,
  privateRoutes.SkillManagement,
  privateRoutes.Dependents,
  {
    label: 'Cadastrar dependentes',
    onClick: () =>
      window.open(
        'https://docs.google.com/forms/d/e/1FAIpQLSdBrf3lkzhl8SE-rLrGZ11xEC7Nlp-VYHrLX7D_ZJXx8NuRIQ/viewform',
        '_blank'
      ),
    check: ({ user, bootstrap }) =>
      !!user?.colaborador?.empresa?.plano_dependente &&
      !user?.colaborador?.employee_id &&
      !bootstrap?.plan?.features?.some(
        (f) => f.name === Features.DependentsIncluded
      ),
  },
  privateRoutes.ChangePassword,
];

export const hrItems: MenuItem[] = [
  privateRoutes.Dashboard,
  privateRoutes.EmployerManagement,
  privateRoutes.SubsidyManagement,
  privateRoutes.LearningPathManagement,
  privateRoutes.LmsReport,
  {
    label: 'Indique uma empresa',
    onClick: () => window.open(ExternalUrls.ReferralLink, '_blank'),
    check: ({ user}) => !!user?.permissoes?.some((permission) => permission.nome === Permissions.HR),
  },
];
